import { gql, useQuery, useSubscription } from "@apollo/client";
import { Card } from "@mui/material";
import PageLayout from "components/LayoutContainers/EmpleadoLayout";
import React, { use, useEffect, useState } from "react";
import DataTable from "components/DataTable";
import SinDatos from "components/Carteles/SinDatos";
import SoftTypography from "components/SoftTypography";
import dataOT from "./data/dataOT";
import SoftBox from "components/CheckBox";
import dayjs from "dayjs";

const OT = () => {
  const [rowsOT, setRowsOT] = useState([]);
  const [dataOTs, setDataOT] = useState([]);
  const { columnsOT, getRowsOT } = dataOT;

  const { data: newOT } = useSubscription(
    gql`
      subscription {
        ordenCreada { id estado updatedAt }
      }
    `)


  const { data: editOT } = useSubscription(
    gql`
    subscription {
      ordenModificada { id estado updatedAt }
    }
  `)

  const { data: dataOrdenes, refetch: refetchOrdenes } = useQuery(
    gql`
      query OT {
        ordenesTrabajoPantalla {
          id
          producto {
            id
            tipoProducto {
              tipo
            }
            nombre
            descripcion
            disponibilidad
            precioCarta
            precioOnline
            precioPorMayor
            esElaborado
            cantidadPorciones
            cantidadPorMayor
          }
          cantPorciones
          estado
          fechaEsperadaEntrega
          observaciones
          createdAt
        }
      }
    `,
    {
      fetchPolicy: "no-cache",
    }
  );

  useEffect(() => {
    setDataOT(dataOrdenes?.ordenesTrabajoPantalla)
  }, [dataOrdenes]);


  useEffect(() => {
    setRowsOT(getRowsOT(dataOTs || []));
  }, [dataOTs]);

  useEffect(() => {
    if (newOT) {
      refetchOrdenes();
    }
  }, [newOT]);

  useEffect(() => {
    refetchOrdenes();
  }, [editOT])


  useEffect(() => {
    const interval = setInterval(refetchOrdenes, 900000); 
    return () => clearInterval(interval); 
  }, []);
  
  


  return (
    <PageLayout background="#f3f3f3">
      <SoftBox display="grid" gridTemplateColumns="1fr" gap={1} alignItems="start">
        <SoftBox display="flex" flexDirection="column" justifyContent="flex-start">
          <SoftBox p={2} mt={2}>
            <Card
              sx={{
                padding: 1,
                marginBottom: 2,
              }}
            >
              <SoftTypography variant="h6" align="center">
                Ordenes de trabajo
              </SoftTypography>
            </Card>
            {dataOTs?.length > 0 ? (
              <DataTable columns={columnsOT} rows={rowsOT} xl />
            ) : (
              <Card>
                <SinDatos
                  titulo="No hay ordenes de trabajo pendientes"
                  mensaje="Cuando haya ordenes de trabajo pendientes, se mostrarán aquí."
                  icono="restaurant"
                />
              </Card>
            )}
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </PageLayout>
  );
};

export default OT;
